import styled from "styled-components";

export const HeaderContainer = styled.div``;

export const HeaderList = styled.ul`
  list-style-type: none;
  width: 100%;
  height: 60px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderListItem = styled.li`
  cursor: pointer;
`;

export const HeaderItems = styled.div`
  width: 15vw;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.3rem;
  // margin-right: 4vw;
`;
